import React, { useRef, useEffect } from "react";
import videojs from "video.js";
import "../../assets/videojs-plus/plugins/live/style.css";
import "../../assets/youtube";
// import "videojs-youtube";
import { isIP } from "net";

function YoutubePlayer({
  src,
  isLive,
  defaultPaused,
  defaultMuted,
}: {
  src: string;
  isLive?: boolean;
  defaultPaused?: boolean;
  defaultMuted?: boolean;
}) {
  const containerRef = useRef(null as any);
  const data = {
    techOrder: ["youtube"],
    title: " ",
    muted: true,
    sources: [{ type: "video/youtube", src: src }],
    youtube: { customVars: { wmode: "transparent" } },
    noUITitleAttributes: true,
    userActions: {
      doubleClick: true,
    },
  };
  useEffect(() => {
    const player = videojs("yt-player", {
      muted: false,
      autoplay: true,
      noUITitleAttributes: true,
      userActions: {
        hotkeys: function (event) {
          let keyCode = event.code.toLowerCase();
          console.log("KEY code>>", keyCode, player.paused());
          switch (keyCode) {
            case "arrowleft":
              var div = document.getElementById("actions-animation");
              if (div) {
                div.className =
                  "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
                div.innerHTML = `
                        <div class="flex flex-row items-center justify-center col-span-1 text-center ">
                            <img src="backward.gif" id="backward-img"/>
                          </div>
                        `;
                setTimeout(() => {
                  if (div) {
                    div.innerHTML = "";
                    div.classList.remove("z-[1000]");
                  }
                }, 600);
              }
              break;
            case "arrowright":
              var div = document.getElementById("actions-animation");
              if (div) {
                div.className =
                  "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
                div.innerHTML = `<div class="col-span-2"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center ">
        <img src="forward.gif" id="forward-img" />
      </div>
    `;
                // document.appendChild(div);
                setTimeout(() => {
                  if (div) {
                    div.innerHTML = "";
                    div.classList.remove("z-[1000]");
                  }
                }, 600);
              }
              break;
            case "space":
              var div = document.getElementById("actions-animation");
              if (div) {
                div.className =
                  "grid grid-cols-3 z-[1000] h-full w-full items-center justify-center text-white absolute";
                div.innerHTML = `<div class="col-span-1"></div>
     <div class="flex flex-row items-center justify-center col-span-1 text-center">
     <div class="play-pause-img-div flex flex-row items-center justify-center opacity-80">
        <img src=${
          player.paused() ? "play.svg" : "pause.svg"
        } id="play-pause-img" class="seek-img" />
      </div>
      </div>
    `;
                setTimeout(() => {
                  if (div) {
                    div.innerHTML = "";
                    div.classList.remove("z-[1000]");
                  }
                }, 300);
              }
          }
        },
      },
    });
    if (isLive) player.live();
    else if (!defaultPaused) {
      player.ready(function () {
        player.autoplay(defaultMuted ? "muted" : "play");
      });
    }
  }, []);

  return (
    <div className="player" ref={containerRef}>
      <video
        muted={false}
        autoPlay={true}
        id={"yt-player"}
        style={{ width: "100%", height: "100%" }}
        data-setup={JSON.stringify(data)}
      ></video>
    </div>
  );
}

export default YoutubePlayer;
